import axios from 'axios'

export const uploadDocument = (formData) => {
  return axios.post('file/shipment/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
    .then(res => res)
    .catch(err => {
      console.log('err', err)
      throw err.response
    })
}

export const downloadRequestInvoice = ({bidId, type, fileName}) => {
  return axios.get(`${type}/invoice/stream/${bidId}`, {responseType: 'blob'})
    .then(res => {
      let blob = new Blob([res.data], {type: res.headers['content-type']})
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      return res
    })
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}

export const getRfqDocument = ({id, rfqNumber}) => {
  return axios.get(`quotation/document/${id}/${rfqNumber}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}

export const getContractDocument = ({id, contractNumber}) => {
  return axios.get(`contract/document/${id}/${contractNumber}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}

export const downloadRequestDetailInvoice = ({bidId, type, fileName}) => {
  return axios.get(`${type}/invoice/detail/${bidId}`, {responseType: 'blob'})
    .then(res => {
      let blob = new Blob([res.data], {type: res.headers['content-type']})
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      return res
    })
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}

export const uploadDoc = (payload) => {
  return axios.post('file/company/upload/doc', payload, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
    .then(res => res)
    .catch(err => {
      console.log('err', err)
      throw err.response
    })
}

export const viewDoc = (payload) => {
  return axios.get(`setting/document/${payload}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err)
      throw err.response
    })
}

export const verifyDoc = () => axios.put('setting/verify/document')
  .then(res => res)
  .catch(err => {
    console.log('err', err)
    throw err.response
  })



// WEBPACK FOOTER //
// ./src/api/file.api.js